import { IconChevronLeft, IconChevronRight, IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { background, black, button, divider, text } from "@/theme/colors";
import { isNumber } from "@/utils/number";
import { Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

type Props = {
  totalPage?: number;
  count?: number;
};

export const Pagination: FC<Props> = ({ totalPage }) => {
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(location.search);
  const page = parseInt(query.get("page") || "1");

  const [displayTotalPage, setDisplayTotalPage] = useState<number>(1);

  useEffect(() => {
    if (isNumber(totalPage)) {
      setDisplayTotalPage(totalPage > 0 ? totalPage : 1);
    }
  }, [totalPage]);

  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <StyledPagination
        page={page}
        count={displayTotalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => {
          const searchParams = new URLSearchParams(search);
          searchParams.set("page", item.page?.toString() ?? "1");

          return (
            <PaginationItem
              component={Link}
              to={{ pathname, search: searchParams.toString() }}
              slots={{ first: IconChevronsLeft, previous: IconChevronLeft, next: IconChevronRight, last: IconChevronsRight }}
              {...item}
            />
          );
        }}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)`
  .MuiPagination-ul {
    gap: 8px;
  }

  .MuiPaginationItem-root {
    width: 40px;
    height: 40px;
    margin: 0;
    padding: 8px;
    border: 1px solid ${divider.high};
    border-radius: 8px;
    background-color: ${background.white};
    color: ${text.secondary};
    font-size: 14px;
    font-weight: 500;
    line-height: 100%;
  }

  .MuiPaginationItem-icon {
    width: 24px;
    height: 24px;
    font-size: 24px;
    color: ${black[80]};
  }

  .MuiPaginationItem-ellipsis {
    border: none;
    background-color: transparent;
  }

  .Mui-disabled {
    color: ${text.disable};
    background-color: ${background.disable};
    border-color: ${divider.middle};
    opacity: 1 !important;
  }

  .Mui-disabled .MuiPaginationItem-icon {
    color: ${text.disable};
  }

  .Mui-selected {
    color: ${text.white};
    background-color: ${button.primary} !important;
    border-color: ${button.primary};
  }

  .Mui-selected:hover {
    cursor: default;
    color: ${text.white};
    background-color: ${button.primary} !important;
  }
`;
